var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDongkou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_6104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4120_6104)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 6.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 2.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "white",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_6104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4120_6104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDongkou);
export default __webpack_public_path__ + "static/media/dongkou.8f7586b293e29f07e966a6de22923a00.svg";
export { ForwardRef as ReactComponent };